// removed by extract-text-webpack-plugin
module.exports = {"app":"index-module__app___Rnpn7"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/app/index.module.scss
// module id = 1556
// module chunks = 147